import { Button, ButtonProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const breadcrumbButtonSx = {
    minWidth: "auto",
    padding: 0,
    textTransform: "none",
    fontWeight: 400,
    color: "text.secondary",

    "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "underline",
    },

    "&:focus-visible": {
        outline: "none",
        textDecoration: "underline",
    },
};

interface Props extends ButtonProps {
    to: string;
}

const BreadcrumbLink = ({ to, children, ...props }: Props) => {
    return (
        <Button
            component={RouterLink}
            to={to}
            variant="text"
            disableRipple
            sx={breadcrumbButtonSx}
            {...props}
        >
            {children}
        </Button>
    );
};

export default BreadcrumbLink;
